import { jsx as _jsx } from "react/jsx-runtime";
import { BadgeWrapper } from './BKJBadge.styled.js';
export const BKJBadge = ({ variant, children, ...rest }) => (_jsx(BadgeWrapper, { variant: variant, ...rest, children: children }));
//# sourceMappingURL=BKJBadge.js.map